import axiosInstance from '../helpers/axios';
import { handleError } from '../helpers/utils';
import { types } from '../types/types';
import { getToken } from './auth';
import { getClients, setClients } from './client';

// Dispatch set catalogs
export const setCatalogs = (data) => ({
	type: types.setCatalogs,
	payload: data,
});

// Dispatch clean catalogs
export const cleanCatalogs = () => ({
	type: types.cleanCatalogs,
});

// Get catalog by name
export const getCatalog = (catalogName) => (dispatch, getState) => {
	// Get token from state
	const { token } = getState().auth;

	const config = {
		headers: {
			'Content-Type': 'application/json',
		},
	};

	// If token, add to headers config
	if (token) config.headers['Authorization'] = `Token ${token}`;

	axiosInstance
		.get(`/api/catalog/${catalogName}/`, config)
		.then(({ data }) => {
			const { results } = data;
			dispatch(setCatalogs({ [catalogName]: results }));
		})
		.catch((error) => {
			handleError(error, 'No se pudo cargar el catálogo de telas');
		});
};

// Get subbiases from one bias
export const getDataByUrl = async (endpoint) => {
	const token = getToken();
	return await axiosInstance({
		method: 'get',
		url: endpoint,
		headers: { Authorization: 'Bearer ' + token },
	});
};

// Get subbiases from one bias
export const getCatalogList = async (catalogName) => {
	const token = getToken();
	return await axiosInstance({
		method: 'get',
		url: `/api/catalog/${catalogName}/`,
		headers: { Authorization: 'Bearer ' + token },
	});
};

export const loadCatalogs = () => {
	return (dispatch) => {
		// Load catalogs
		dispatch(getCatalog('garment'));
		dispatch(getCatalog('area'));
		dispatch(getCatalog('size'));
		dispatch(getCatalog('variant'));
		dispatch(getCatalog('fabric'));
		dispatch(getCatalog('usertype'));
		dispatch(getCatalog('variable'));
		console.log('Se cargaron los catálogos ✅');
	};
};

export const loadClients = (pageSize = 100) => {
	return (dispatch) => {
		getClients(null, pageSize).then(({ data }) =>
			dispatch(
				setClients(
					data.results.map((item) => ({
						id: item.id,
						company_name: item.company_name,
					}))
				)
			)
		);
		console.log('Se cargaron los clientes ✅');
	};
};
